<script>
    // core components
    import BodegaView from "../../viewsERP/Bodega.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <BodegaView />
    </div>
  </div>